var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.showDialog,"z-index":"99999"}},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"main"},[_c('div',[_vm._v("登录方式不正确")]),_vm._v(" "),_c('div',[_vm._v("请在微信公众号里点击图文链接的方式进入")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22643934","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/UserInfoHandle.vue
// module id = null
// module chunks = 